import { ToolbarProps, Toolbar, Typography } from '@mui/material';
import styles from './CustomTableToolbar.styles';

interface CustomTableToolbarProps extends ToolbarProps {
  title: string;
  dataLength: number;
}

const CustomTableToolbarComponent = function ({
  title,
  dataLength,
  ...props
}: CustomTableToolbarProps): JSX.Element {
  return (
    <Toolbar sx={styles.container} {...props}>
      <Typography sx={styles.text} color="inherit" component="div">
        {title} table ({dataLength})
      </Typography>
    </Toolbar>
  );
};

export default CustomTableToolbarComponent;
